module.exports = __webpack_public_path__ + "static/media/life-redemption-gift-preview.774fdbf6.jpg";